import { Component } from "react";
import { CommonService } from "../js_modules/CommonService";
import { SellToWebAdminDropdownComponent } from "../common/selltowebdropdown/SellToWebAdminDropdownComponent";
import { SellToWebSpinnerComponent } from "../common/selltowebspinner/SellToWebSpinnerComponent";
import { AdminRouteComponent } from "../admin/AdminRouteComponent";

export class TenantSiteDetailQueryComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTenant: null,
            sites: null,
            selectedSite: null,
            showSpinner: false
        };

        this.onTenantClick = this.onTenantClick.bind(this);
        this.onSiteClick = this.onSiteClick.bind(this);
        this.onGetClick = this.onGetClick.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
    }

    componentDidUpdate() {
        try {
            if (this.props.tenants && !this.state.selectedTenant) {
                let selectedTenant = null;
                let urlPath = window.location.pathname.split("/");
                let tenantGuid = urlPath[3];
                if (tenantGuid !== "") {
                    selectedTenant = this.props.tenants.find(tenant => tenant.guid === tenantGuid);
                }
                let cookieTenant = CommonService.getCookie(AdminRouteComponent.TenantCookie);
                if (!selectedTenant && cookieTenant !== "") {
                    selectedTenant = this.props.tenants.find(tenant => tenant.guid === cookieTenant);
                }
                if (!selectedTenant) {
                    selectedTenant = this.props.tenants[0];
                }

                this.setState({
                    selectedTenant: selectedTenant
                }, this.onTenantClick(null, selectedTenant));
            }
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailQueryComponent", "componentDidUpdate");
        }
    }

    getSites() {
        this.setState({ showSpinner: true });

        let inputData = {
            tenantGuid: this.state.selectedTenant.guid,
        };
        this.props.applicationInsights.trackTrace({ message: "TenantSiteDetailQueryComponent/getSites", properties: { ...inputData, logon: this.props.logon } });
        fetch("/TenantSite/GetSites", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8;"
            },
            body: JSON.stringify(inputData),
            credentials: "same-origin"
        })
            .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
            .then(parsedResponse => {
                if (!this.state.selectedSite) {
                    let selectedSite = null;
                    let urlPath = window.location.pathname.split("/");
                    let siteGuid = urlPath[4];
                    if (siteGuid !== "") {
                        selectedSite = parsedResponse.find(site => site.guid === siteGuid);
                    }
                    let cookieSite = CommonService.getCookie(AdminRouteComponent.SiteCookie);
                    if (!selectedSite && cookieSite !== "") {
                        selectedSite = parsedResponse.find(site => site.siteName === cookieSite);
                    }
                    if (!selectedSite) {
                        selectedSite = parsedResponse[0];
                    }

                    this.setState({
                        sites: parsedResponse,
                        selectedSite: selectedSite,
                        showSpinner: false,
                    }, this.onSiteClick(null, selectedSite));
                }
                else {
                    this.setState({
                        showSpinner: false,
                        sites: parsedResponse
                    });
                }
            })
            .catch(notOKResponse => {
                this.setState({
                    showSpinner: false
                });
                if (notOKResponse.status === 500) {
                    notOKResponse.json()
                        .then(parsedError => {
                            this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/GetSites", ...inputData, ...parsedError, logon: this.props.logon } });
                            console.logError(parsedError, "TenantSiteDetailQueryComponent", "getSites");
                            this.props.onShowAlert("danger", parsedError);
                        })
                        .catch(jsonParseError => {
                            console.logError(jsonParseError, "TenantSiteDetailQueryComponent", "getSites");
                        });
                }
            });
    }

    onTenantClick(event, selectedTenant) {
        try {
            CommonService.setCookie(AdminRouteComponent.TenantCookie, selectedTenant ? selectedTenant.guid : "", 30);

            this.setState({
                selectedTenant: selectedTenant,
                selectedSite: null
            }, this.getSites);

        }
        catch (error) {
            console.logError(error, "TenantSiteDetailQueryComponent", "onTenantClick");
        }
    }

    onSiteClick(id, selectedSite) {
        try {
            CommonService.setCookie(AdminRouteComponent.SiteCookie, selectedSite ? selectedSite.siteName : "", 30);
            this.setState({
                selectedSite: selectedSite
            }, this.onGetClick);
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailQueryComponent", "onSiteClick");
        }
    }

    onGetClick(event) {
        try {
            this.props.onGetClick(this.state.selectedSite);
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailQueryComponent", "onGetClick");
        }
    }

    onSaveClick() {
        try {
            this.props.onSaveClick(this.state.selectedSite, this.state.selectedTenant);
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailQueryComponent", "onSaveClick");
        }
    }


    render() {
        return <div className="card">
            <div className="card-block">
                <div className="row">
                    {
                        this.props.isGlobalAdmin
                            ? <SellToWebAdminDropdownComponent label="Tenant" data={this.props.tenants} itemKey="name" onItemClick={this.onTenantClick} value={this.state.selectedTenant ? this.state.selectedTenant.name : "Select Tenant"} controlSpan="admin-tenant-control" />
                            : <div className="admin-control col-auto">
                                <div className="input-group align-items-center">
                                    <label className="admin-label col-form-label">
                                        Tenant:
                                    </label>
                                    {this.state.selectedTenant?.name}
                                </div>
                            </div>
                    }
                    <SellToWebAdminDropdownComponent label="Site" data={this.state.sites} itemKey="siteName" onItemClick={this.onSiteClick} value={this.state.selectedSite ? this.state.selectedSite.siteName : "Select Site"} />
                    <div className="col-auto admin-query-btn">
                        <button className="btn btn-primary" disabled={this.state.showSpinner} onClick={(event) => this.onGetClick(event)}>
                            Get <i className="far fa-redo-alt admin-icon" />
                        </button>
                        <button className="btn btn-primary admin-icon" onClick={this.onSaveClick} disabled={this.state.showSpinner || !this.props.canEdit}>
                            Save <i className="fas fa-save admin-icon" />
                        </button>
                        {
                            this.state.selectedSite
                                ? <a className="btn btn-primary admin-icon" target="_blank" rel="noreferrer" href={"https://" + this.state.selectedSite.siteDomain}>
                                    View Site
                                </a>
                                : null
                        }
                    </div>
                    <div style={{ "height": "33px", "width": "auto" }}>
                        <SellToWebSpinnerComponent className="admin-icon" showSpinner={this.state.showSpinner || this.props.isLoadingData} />
                    </div>
                </div>
            </div>
        </div>;
    }
}